/**
 * @generated SignedSource<<add389287e63a3a053bb3d7a61809b7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ManageVaultFieldsModal_vaultManager_Query$variables = {};
export type ManageVaultFieldsModal_vaultManager_Query$data = {
  readonly vaultManager: {
    readonly availableFields: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
        } | null;
      }>;
    };
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"VaultFieldInput_vaultManager">;
  };
};
export type ManageVaultFieldsModal_vaultManager_Query = {
  response: ManageVaultFieldsModal_vaultManager_Query$data;
  variables: ManageVaultFieldsModal_vaultManager_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "VaultFieldConnection",
  "kind": "LinkedField",
  "name": "availableFields",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VaultFieldEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VaultField",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ManageVaultFieldsModal_vaultManager_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VaultManager",
        "kind": "LinkedField",
        "name": "vaultManager",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VaultFieldInput_vaultManager"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ManageVaultFieldsModal_vaultManager_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VaultManager",
        "kind": "LinkedField",
        "name": "vaultManager",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultConnection",
            "kind": "LinkedField",
            "name": "vaults",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "VaultEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vault",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VaultFieldValue",
                        "kind": "LinkedField",
                        "name": "fieldValues",
                        "plural": true,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VaultField",
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce5ab829b697d0d59c17bfbb7d2ceb8a",
    "id": null,
    "metadata": {},
    "name": "ManageVaultFieldsModal_vaultManager_Query",
    "operationKind": "query",
    "text": "query ManageVaultFieldsModal_vaultManager_Query {\n  vaultManager {\n    id\n    availableFields {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    ...VaultFieldInput_vaultManager\n  }\n}\n\nfragment VaultFieldInput_vaultManager on VaultManager {\n  id\n  vaults {\n    edges {\n      node {\n        id\n        fieldValues {\n          id\n          field {\n            id\n          }\n          value\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bf30a4aec4b2cbd7fc5d52d053165c0";

export default node;
